import React, { useContext } from 'react'
import { MotorBikesContext } from '../../../../contexts/motorBikesContext'
import InputsElements from '../../../../elements/InputsElements'

function InternalSerialNumbrer() {

    const { currentVehiclesData = {} } = useContext(MotorBikesContext)
    const { currentService = {} } = useContext(MotorBikesContext)

    return <InputsElements
        label="N° de Serie de Fabricante"
        name="InternalSerialNum"
        value={currentVehiclesData?.InternalSerialNum ?? currentService?.InternalSerialNum ?? ''}
        inputState={true}
    />
}

export default InternalSerialNumbrer